module.exports = __webpack_public_path__ + "img/coupon_tutorial_imymerry04.fff3bd14.png";